<template>
  <div class="login-container">
    <el-card class="login-card">
      <template #header>
        <div class="card-topbar">
          <span class="brand-mark">S</span>
          <el-radio-group @change="selectLang" v-model="lang" size="small">
            <el-radio-button :label="$t('lang.zh')" value="zh" />
            <el-radio-button :label="$t('lang.en')" value="en" />
          </el-radio-group>
        </div>
        <h1>Sylvox产品服务平台</h1>
        <p class="login-subtitle">欢迎登录您的业务工作台</p>
      </template>
      <el-form :model="loginForm" class="login-form">
        <el-form-item>
<!--          <label for="login-account">{{$t('login.account')}}</label>-->
          <el-input
            id="login-account"
            class="height-40"
            v-model="loginForm.username"
            :placeholder="$t('login.account')"
          ></el-input>
        </el-form-item>
        <el-form-item>
<!--          <label for="login-password">{{$t('login.pwd')}}</label>-->
          <el-input
            id="login-password"
            class="height-40"
            v-model="loginForm.password"
            type="password"
            show-password
            :placeholder="$t('login.pwd')"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="handleLogin" class="login">
          <span class="login-button-label">登录系统</span>
          <span class="login-button-arrow" aria-hidden="true">→</span>
        </el-button>
      </el-form>
      <div class="form-service-tags">
        <span>✓ 安全访问</span>
        <span>·</span>
        <span>专业支持</span>
        <span>·</span>
        <span>高效协同</span>
      </div>
      <p class="login-footer">Sylvox · Global Operations</p>
    </el-card>
  </div>
</template>

<script>
import {token} from "@/utils/api";
import {ElCard,ElForm,ElFormItem,ElInput,ElButton,ElRadioGroup,ElRadioButton} from "element-plus";
export default {
  name: "AdminLogin",
  components:{
    ElCard,ElForm,ElFormItem,ElInput,ElButton,ElRadioGroup,ElRadioButton
  },
  data() {
    return {
      windowWidth:1280,
      lang:"zh",
      loginForm: {
        username: "",
        password: "",
      },
    };
  },
  mounted() {
    this.windowWidth = window.innerWidth
    this.lang = localStorage.getItem('lang') || "zh"
    window.addEventListener('resize', this.updateWidth)
    this.loginForm.username = localStorage.getItem('username')=='null' ? '' :  localStorage.getItem('username')
  },
  unmounted() {
    window.removeEventListener('resize', this.updateWidth)
  },
  methods: {
    selectLang(){
      this.$i18n.locale = this.lang
      localStorage.setItem('lang',this.lang);
    },
    updateWidth() {
      this.windowWidth = window.innerWidth
      console.log(this.windowWidth)
    },
    async handleLogin() {

      // 创建 FormData 对象
      const formData = new FormData();
      formData.append("username", this.loginForm.username);
      formData.append("password", this.loginForm.password);
      // 发送表单格式的请求
      token(formData).then(res=>{
        localStorage.setItem("username", this.loginForm.username);
        localStorage.setItem("token", res.data.access_token);
        localStorage.setItem("permission",JSON.stringify(res.data.permission) );
        this.$router.push("/");
      }).catch(err=>{
        console.log("Login error:", err);
        //ElMessage.error(err.response?.data?.detail || "登录失败");
      })
    },
  },
};
</script>

<style scoped>
.login-container {
  align-items: center;
  background: linear-gradient(100deg, rgba(7, 42, 29, .48) 0%, rgba(9, 67, 43, .26) 47%, rgba(10, 57, 37, .18) 100%), url("../../public/login-patio-background.png") center / cover no-repeat;
  box-sizing: border-box;
  display: flex;
  height: 100vh;
  justify-content: flex-end;
  min-height: 620px;
  overflow: hidden;
  padding: 32px clamp(155px, 17vw, 320px) 32px 32px;
  position: relative;
}


.login-card {
  background: rgba(4, 57, 35, .91);
  border: 1px solid rgba(181, 226, 196, .44);
  border-radius: 24px;
  box-shadow: 0 24px 70px rgba(2, 35, 21, .52) !important;
  color: #fff;
  overflow: hidden;
  position: relative;
  min-height: 680px;
  width: 600px;
  z-index: 1;
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);
  animation: login-card-float 5s ease-in-out infinite;
  transform: translateZ(0);
}

@keyframes login-card-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

::v-deep .el-card__header { border-bottom: 1px solid rgba(218, 245, 222, .26); padding: 46px 48px 34px; }
::v-deep .el-card__body { padding: 42px 48px 34px; }
.card-topbar { align-items: center; display: flex; justify-content: space-between; margin-bottom: 25px; }
.brand-mark { align-items: center; background: rgba(214, 247, 222, .18); border: 1px solid rgba(214,247,222,.55); border-radius: 11px; display: inline-flex; font-family: Georgia, serif; font-size: 23px; font-weight: 700; height: 40px; justify-content: center; width: 40px; }
h1 { font-size: 29px; font-weight: 600; letter-spacing: .5px; line-height: 1.3; margin: 0; }
.login-subtitle { color: rgba(255, 255, 255, .74); font-size: 16px; margin: 10px 0 0; }
::v-deep .el-radio-button__inner { background: rgba(12, 88, 55, .88); border-color: rgba(155, 218, 174, .38); box-shadow: none; color: rgba(255,255,255,.9); }
::v-deep .el-radio-button__inner:hover { color: #fff; }
::v-deep .el-radio-button__original-radio:checked + .el-radio-button__inner { background: #168851 !important; border-color: #5cbe83 !important; box-shadow: -1px 0 0 0 rgba(155, 218, 174, .38) !important; color: #fff !important; }
.login-form { margin: 0 auto; width: 75%; }
.login-form label { color: rgba(255,255,255,.88); display: block; font-size: 13px; margin-bottom: 8px; }
::v-deep .el-form-item { margin-bottom: 28px; }
.height-40 { height: 60px; }
::v-deep .el-input__wrapper { background: rgba(255,255,255,.94); border-radius: 13px; box-shadow: none; padding: 1px 20px; }
::v-deep .el-input__wrapper.is-focus { box-shadow: 0 0 0 2px rgba(125, 217, 160, .7); }
.login {
  background: linear-gradient(105deg, #147647 0%, #24945a 54%, #43ae70 100%);
  border: 1px solid rgba(137, 221, 166, .28);
  border-radius: 13px;
  box-shadow: 0 10px 24px rgba(2, 42, 24, .34), inset 0 1px 0 rgba(255, 255, 255, .18);
  font-size: 18px;
  height: 62px;
  margin-top: 8px;
  overflow: hidden;
  position: relative;
  transition: background .25s ease, box-shadow .25s ease, transform .25s ease;
  width: 100%;
}
.login::before {
  background: linear-gradient(110deg, transparent 30%, rgba(255, 255, 255, .12) 50%, transparent 70%);
  content: "";
  inset: 0;
  opacity: .55;
  pointer-events: none;
  position: absolute;
  transform: translateX(-70%);
  transition: transform .55s ease;
}
.login-button-label { font-weight: 600; letter-spacing: 1px; position: relative; z-index: 1; }
.login-button-arrow {
  font-size: 22px;
  opacity: .76;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-52%);
  transition: opacity .25s ease, right .25s ease;
  z-index: 1;
}
.login:hover, .login:focus {
  background: linear-gradient(105deg, #16814d 0%, #299e62 54%, #4ab978 100%);
  box-shadow: 0 13px 28px rgba(2, 42, 24, .4), inset 0 1px 0 rgba(255, 255, 255, .22);
  transform: translateY(-2px);
}
.login:hover::before, .login:focus::before { transform: translateX(70%); }
.login:hover .login-button-arrow, .login:focus .login-button-arrow { opacity: 1; right: 20px; }
.login:active { box-shadow: 0 6px 15px rgba(2, 42, 24, .34); transform: translateY(0); }
.form-service-tags { align-items: center; color: rgba(223, 247, 230, .66); display: flex; font-size: 12px; gap: 9px; justify-content: center; margin-top: 24px; }
.login-footer { color: rgba(255,255,255,.62); font-size: 12px; letter-spacing: .7px; margin: 19px 0 0; text-align: center; }

@media screen and (max-width: 600px) {
  .login-container { justify-content: center; min-height: 100vh; padding: 20px; }
  .login-card { min-height: auto; width: 100%; }
  .login-form { width: 100%; }
  ::v-deep .el-card__header { padding: 24px 24px 19px; }
  ::v-deep .el-card__body { padding: 22px 24px 16px; }
  h1 { font-size: 22px; }
}
</style>
